import React, { use, useContext, useEffect, useState } from "react";
import {
  MyBookPanditCategoryAPI,
  MyBookPanditPujaListAPI,
} from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import "./BookPandit.css";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import Batuk from "../../assets/images/new/Batuk2.png";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import Android12Switch from "../../Components/AndroidSwitch";
import Select from "react-select";
import Breadcrumbs from "../../Components/Breadcrumb";
import { customSelectStyles } from "../../middlewares/Utils";

const BookPandit = () => {
  const [myBookPanditData, setMyBookPanditData] = useState([]);
  const [pujaListData, setPujaListData] = useState([]);
  const [catID, setCatID] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedCatId, setSelectedCatId] = useState(null);
  const { setLoader, loader, pujaStatus, setPujaStatus } =
    useContext(LoaderContext);
  const user_id = localStorage.getItem("userID");
  const location = useLocation()
  const navigate = useNavigate();
  const [status, setStatus] = useState(
    pujaStatus === null ? false : pujaStatus
  );
  const [myBookPanditDataMobile, setMyBookPanditDataMobile] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Adjust breakpoint as needed
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (catID === null || catID === undefined || catID === "") {
      GetMyBookPanditCategoryData();
    }
  }, [user_id]);

  useEffect(() => {
    if (catID !== null && catID !== undefined && catID !== "") {
      const ID = status ? 1 : 2;
      GetMyBookPanditCategoryData();
      GetMyBookPanditPujaListData(ID);
    }
  }, [catID, status]);


  useEffect(() => {
    if (location?.state?.selectedCat !== null && location?.state?.selectedCat !== undefined) {
      setCatID(location?.state?.selectedCat)
      setSelectedCatId(location?.state?.selectedCat)
    }
  }, [location])

  const GetMyBookPanditCategoryData = async () => {
    setLoader(true);
    const response = await MyBookPanditCategoryAPI(user_id);

    try {
      if (
        response.ResponseMessage === "list" &&
        response.ResponseCode === "0"
      ) {
        // setMyBookPanditData(response.DATA);
        const Data = response.DATA
        let filteredData = []
        if (status) {
          filteredData = Data?.filter((val, index) => val?.OnlinePujaCount > 0)
          setMyBookPanditData(filteredData);
        } else if (status === false) {
          filteredData = Data?.filter((val, index) => val?.OfflinePujaCount > 0)
          setMyBookPanditData(filteredData);
        } else {
          setMyBookPanditData(Data);
          filteredData = Data
        }



        const options = filteredData.filter(
          (item) => item.PUJACAT_ID && item.PUJACAT_NAME
        ).map((item) => ({
          value: item.PUJACAT_ID,
          label: item.PUJACAT_NAME,
        }));
        debugger
        setMyBookPanditDataMobile(options);
        const storedCatId = sessionStorage.getItem("selectedCatId");
        const isExist = options?.some(option => Number(option?.value) === Number(storedCatId));
        if (isExist) {
          if (storedCatId !== null && storedCatId !== undefined && Number(storedCatId) > 0) {
            setCatID(Number(storedCatId));
            setSelectedCatId(Number(storedCatId));
          } else {
            setCatID(filteredData[0]?.PUJACAT_ID);
            setSelectedCatId(filteredData[0]?.PUJACAT_ID);
          }
        } else {
          setCatID(filteredData[0]?.PUJACAT_ID);
          setSelectedCatId(filteredData[0]?.PUJACAT_ID);
        }


      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetMyBookPanditPujaListData = async (requestedFilter) => {
    setLoader(true);
    try {
      const response = await MyBookPanditPujaListAPI(user_id, catID, {
        START: 1,
        END: 1000,
        WORD: "None",
        LATITUDE: "20.008581",
        LONGITUDE: "73.76413099999999",
      });

      if (response) {
        setLoader(false);
        const filteredData = response?.DATA?.filter(
          (value, index) =>
            value.PoojaTypeID === requestedFilter || value.PoojaTypeID === 3
        );
        setPujaListData(filteredData);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const viewDetail = (product) => {
    // We will receive slug from backend for the product:
    // const slug = product.slug;
    // Data will not be shared using state now, we will call API for data depending on the slug we got.
    // const newSlug = product?.PUJA_NAME.split(" ").join("-").toLowerCase();
    const newSlug = product?.PujaSlug;
    console.log("Navigating to details with product:", newSlug);

    if (catID) {
      sessionStorage.setItem("selectedCatId", catID);
    }

    navigate(`/services/book-puja/${newSlug}`, {
      state: { product: product, PujaStatus: status ? 1 : 2 },
    });
  };

  console.log(myBookPanditData);

  const ProductCard = ({ product, viewDetail, placeholderImg }) => {
    return (
      <div
        className="col-lg-3 col-md-6 col-sm-6 product-item-one "
        style={{ marginBottom: "15px", width: isMobile ? "20em" : "12em" }}
      >
        <div
          className=" card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100  "
          style={{ cursor: "pointer" }}
          onClick={() => viewDetail(product)}
        >
          <div className="product-image text-center position-relative ">
            <img
              src={product.PUJA_IMAGE || placeholderImg}
              alt={product.PUJA_NAME}
              className="img-fluid rounded w-100"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = placeholderImg;
              }}
              style={{ objectFit: "contain", height: "180px" }}
            />
            {/* <span className="discount-badge position-absolute top-0 start-0 bg-danger text-white p-1 small">
              {product.PUJA_DISC ? `${product.PUJA_DISC}% OFF` : ""}
            </span> */}
          </div>
          <div
            className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2"
            style={{ margin: "0" }}
          >
            <h6
              style={{
                fontSize: "18px",
                color: "#8f3246",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {product.PUJA_NAME}
            </h6>
            <div className="prod-details d-flex align-items-center flex-column">
              <span style={{ fontSize: "16px", whiteSpace: "nowrap" }}>
                ₹{" "}
                {status
                  ? Math.round(
                    product.OnlinePujaPrice - product.OnlinePujaDiscountAmount
                  )
                  : Math.round(product.PUJA_PRICE - product.DiscountAmount)}
                {/* {product.PUJA_PRICE - product.DiscountAmount} */}
              </span>
              <span
                style={{
                  whiteSpace: "nowrap",
                  color: "#a52444",
                  fontSize: "15px",
                  // borderBottom: "1px solid",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "5px",
                }}
              >
                View Details <i className="icon-right-arrow"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleCatChange = (category) => {
    setCatID(category.PUJACAT_ID);
    setSelectedCatId(category.PUJACAT_ID);
    sessionStorage.setItem("selectedCatId", category?.PUJACAT_ID);
  }

  const HandlePujaTypeChange = () => {
    if (status) {
      setPujaStatus(false)
    } else {
      setPujaStatus(true)
    }

    setStatus(!status)
  }
  return (
    <>
      <section className="page-header" style={{ height: isMobile && "225px" }}>
        <div className="page-header__bg"></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">Book Puja</h2>
        </div>
      </section>

      <div className="main">
        <div className="container">
          {/* Use flex-column-reverse only for small screens */}
          <div className="row">
            <div style={{ padding: "8px" }}>
              <Breadcrumbs />
            </div>
            {/* Category List - Always First in Mobile */}
            {!isMobile ? (
              <div
                className="left col-md-3 col-sm-4 "
              // style={{ padding: "20px" }}
              >
                <div>
                  <h4
                    className=" custom-list-item clearfix"
                    style={{
                      fontFamily: "poppins",
                      fontSize: "20px",
                      borderBottom: "1px solid lightgray",
                      textTransform: "none",
                      padding: "12px",
                    }}
                  >
                    Puja Category
                  </h4>
                  <ul className="margin-bottom-25 sidebar-menu">
                    {myBookPanditData?.length > 0 ? (
                      myBookPanditData.map((category, index) => (
                        <li className="list-group-item clearfix" key={index}>
                          <Link
                            to="#"
                            onClick={() => handleCatChange(category)}
                            className={`d-flex align-items-center ${selectedCatId === category.PUJACAT_ID
                              ? "active"
                              : ""
                              }`}
                          >
                            <i className="fa fa-angle-right me-2"></i>
                            {category.PUJACAT_NAME?.length > 30 ? (
                              <Tooltip title={category.PUJACAT_NAME}>
                                {`${category.PUJACAT_NAME.substring(0, 19)}...`}
                              </Tooltip>
                            ) : (
                              category.PUJACAT_NAME
                            )}
                          </Link>
                        </li>
                      ))
                    ) : (
                      <li className="list-group-item">
                        No categories available
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            ) : (
              <Select
                styles={customSelectStyles}
                options={myBookPanditDataMobile}
                placeholder="Select Category"
                value={myBookPanditDataMobile.find(
                  (option) => option.value === catID
                )}
                onChange={(selectedOption) => {
                  setCatID(selectedOption.value);
                  setSelectedCatId(selectedOption.value);
                }}
              />
            )}

            {/* Product List - Always Below Categories in Mobile */}
            <div className="right col-md-8 col-sm-8 px-lg-5">
              <div style={{ justifyContent: "end", display: "flex" }}>
                <span>Offline Puja</span>
                <Android12Switch
                  style={{ padding: "8px" }}
                  onClick={() => HandlePujaTypeChange()}
                  checked={status}
                />
                <span>Online Puja</span>
              </div>
              {pujaListData?.length !== 0 ? (
                <div className="d-flex flex-wrap gap-2 product-list">
                  {pujaListData
                    ?.filter(
                      (product) =>
                        search === "" ||
                        product.PUJA_NAME.toLowerCase().includes(
                          search.toLowerCase()
                        )
                    )
                    ?.map((product) => (
                      <ProductCard
                        key={product.PUJA_ID}
                        product={product}
                        viewDetail={viewDetail}
                        placeholderImg={placeholderImg}
                      />
                    ))}
                </div>
              ) : loader === false ? (
                <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                  <img
                    src={Batuk}
                    alt="Empty Cart"
                    className="img-fluid mb-3"
                    style={{ maxWidth: "200px" }}
                  />
                  <h5 className="fw-bold" style={{ textAlign: "center" }}>
                    No services available for this category
                  </h5>
                  <p className="text-muted">
                    Please explore our other categories.
                  </p>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookPandit;
